
export default function QuienesSomos() {
  return (
    <section id="quienes-somos" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="grid lg:grid-cols-5 gap-16 items-center">
          <div className="lg:col-span-2">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              CDE MIPYME RVS
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-12">
              Somos una organización dedicada al fortalecimiento y desarrollo de las micro, pequeñas y medianas empresas del Valle de Sula. Trabajamos para mejorar la competitividad, productividad y formalización de los negocios en nuestra región, contribuyendo al desarrollo económico local de Honduras.
            </p>

            <div className="grid grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-[#0066CC] mb-2">500+</div>
                <div className="text-sm text-gray-600 leading-tight">Empresas Asesoradas</div>
              </div>
              <div className="text-center border-l border-r border-gray-200">
                <div className="text-4xl font-bold text-[#0066CC] mb-2">1,200+</div>
                <div className="text-sm text-gray-600 leading-tight">Emprendedores Capacitados</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#0066CC] mb-2">13+</div>
                <div className="text-sm text-gray-600 leading-tight">Años de Experiencia</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3 relative h-[500px]">
            <div className="absolute inset-0 rounded-3xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/b286a2ed3ca10247dabf9d64ba360efd/c8696f5d52c183d6ebd4b3aaf8eb9779.jpeg"
                alt="Atención personalizada CDE MIPYME RVS - asesoría empresarial"
                title="Asesoría empresarial CDE MIPYME RVS"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="mt-24 grid md:grid-cols-3 gap-12">
          <div>
            <div className="w-14 h-14 bg-[#0066CC]/10 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-target-line text-3xl text-[#0066CC]"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Misión</h3>
            <p className="text-gray-600 leading-relaxed">
              Somos una organización de desarrollo económico, que articula acciones con el sector público, privado, academia y cooperación internacional para contribuir al desarrollo económico de la región mediante medios de vida dignos a través de la empleabilidad, emprendimiento y formación técnica especializada.
            </p>
          </div>

          <div>
            <div className="w-14 h-14 bg-[#2E7D32]/10 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-eye-line text-3xl text-[#2E7D32]"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Visión</h3>
            <p className="text-gray-600 leading-relaxed">
              Ser la organización líder en el impulso del desarrollo económico regional, reconocida por su capacidad de articulación multisectorial, innovación social y compromiso con la generación de medios de vida dignos, sostenibles e inclusivos.
            </p>
          </div>

          <div>
            <div className="w-14 h-14 bg-[#5D4037]/10 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-heart-line text-3xl text-[#5D4037]"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Valores</h3>
            <p className="text-gray-600 leading-relaxed">
              Integridad, excelencia, solidaridad, servicio, transparencia y ética profesional. Principios que guían nuestro trabajo diario para impulsar el desarrollo empresarial de la región.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
